// extracted by mini-css-extract-plugin
module.exports = {"root":"EnquiryPanel_root__3Dz-H","heading":"EnquiryPanel_heading__20EO1","contactForm":"EnquiryPanel_contactForm__3RLFG"};